/* eslint-disable max-lines-per-function */
import { EventBus, Events } from "jiffy-store";
import { api } from "jiffy-api";
import "./product-details-notify-on-restock-sign-in.scss";

export default () => {
  const $$modal = $(".js-product-details-notify-on-restock-sign-in");
  if (!$$modal.length) return;

  const modalClose = $(".js-product-details-notify-on-restock-sign-in-close");
  const modalForm = $(".js-product-details-notify-on-restock-sign-in-form");
  const errorsContainer = $(".js-product-details-notify-on-restock-sign-in-error");
  const modalOpen = document.querySelectorAll(".js-product-details-notify-on-restock-modal-open");
  const footerButton = document.querySelector(".js-restock-sign-in-footer-button");

  const initModalOpen = buttons => {
    buttons.forEach(btn => {
      const parentBlock = btn.parentElement;
      const { color, productId } = parentBlock.dataset;

      btn.addEventListener("click", async () => {
        $$modal.modal("show");
        $$modal.find("input[type='email']").first().trigger("focus");

        await api.favorites.addFavoriteItem({
          product_slug: productId,
          ac: color,
          notify_state: "subscribed"
        });
      });
    });
  };

  initModalOpen(modalOpen);

  modalForm.on({
    "ajax:before": () => {
      errorsContainer.hide();
    },
    "ajax:error": (_event, error) => {
      errorsContainer.show().text(JSON.parse(error.responseText).error_message);
    }
  });

  modalClose.on("click", () => {
    errorsContainer.hide();
    $$modal.modal("hide");
  });

  EventBus.on(Events.MOBILE_GRID_LOADED, () => {
    const newModalOpen = document.querySelectorAll(
      ".js-product-details-notify-on-restock-modal-open:not(.inited)"
    );
    initModalOpen(newModalOpen);
  });

  EventBus.on(Events.PRODUCT_COLOR_SELECTED, () => {
    const nextPage = encodeURIComponent(window.location.pathname + window.location.search);

    footerButton.href = footerButton.href.replace(
      /(next_page=)(.*)(&)/gi,
      `next_page=${nextPage}&`
    );

    modalForm[0].action = modalForm[0].action.replace(
      /(&)(product_redirect=)(.*)/gi,
      `&product_redirect=${nextPage}`
    );
  });
};
